import { FC } from 'react';

import { CloudinaryImage } from 'components/common/CloudinaryImage';
import { ListingCondition } from 'types';

export const EmptyRequestsTabContentTestIds = {
  container: 'empty-requests-tab-content-container'
};

export type EmptyRequestsTabContentProps = {
  selectedTab: ListingCondition;
};

export const TabTextMap = {
  [ListingCondition.Unworn]: 'an unworn',
  [ListingCondition.Preowned]: 'a pre-owned'
};

export const EmptyRequestsTabContent: FC<EmptyRequestsTabContentProps> = ({ selectedTab }) => (
  <div data-testid={EmptyRequestsTabContentTestIds.container} className='fs-16px text-center letter-spacing-007 pt-3'>
    <CloudinaryImage
      alt={`${selectedTab} image placeholder`}
      src={`bezel-web/purchase_requests_${selectedTab === ListingCondition.Unworn ? 'unworn' : 'preowned'}_empty_state_gradient.png`}
      width={180}
      height={250}
      style={{ objectFit: 'cover' }}
    />
    <div className='position-relative' style={{ bottom: 100 }}>
      <div className='opacity-90'>No {selectedTab.toLowerCase()} requests yet</div>
      <div className='riforma-regular mt-3 opacity-60'>
        Once a purchase request is submitted for {TabTextMap[selectedTab]} example of this model, it will be available
        here
      </div>
    </div>
  </div>
);
